import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import FooterBar from "../components/FooterBar";
import HeaderBar from "../components/HeaderBar";

const { Content } = Layout;

export default function LayoutWrapper() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <HeaderBar />
      <Content style={{ padding: "24px" }}>
        <Outlet />
      </Content>
      <FooterBar />
    </Layout>
  );
}
